export default Object.freeze({
  PENDING: 'PENDING',
  PARTIAL: 'PARTIAL',
  CONFLICTED: 'CONFLICTED',
  COMPLETE: 'COMPLETE',
});
